import { Component } from '@angular/core';
import { AuthService } from 'app/services/auth/auth.service';
import { LOGIN_TERMS_NOTICE_LINES } from '../login-text.constants';

/**
 * SSO LOGIN COMPONENT
 *
 * Handles the SSO authentication flow from the welcome page.
 *
 * Responsibilities:
 * - Display SSO sign-in button
 * - Redirect to Keycloak on button click
 */
@Component({
  selector: 'sso-login',
  template: `
    <div class="login-content">
      <div class="auth-fields"></div>

      <div class="auth-cta-section">
        <!-- LEGACY SSO FLOW: Simple button that redirects to Keycloak -->
        <button type="button" class="next-button" (click)="onSignInWithSSO()">Sign in with SSO</button>

        <!-- TERMS NOTICE -->
        <div class="terms-notice">
          @for (line of termsNoticeLines; track $index) {
            <p>{{ line }}</p>
          }
        </div>
      </div>
    </div>
  `,
  standalone: true,
  styleUrl: '../login-screen.component.scss'
})
export class SsoLoginComponent {
  readonly termsNoticeLines = LOGIN_TERMS_NOTICE_LINES;

  constructor(private readonly _auth: AuthService) {}

  /**
   * SIGN IN WITH SSO
   * Redirects user to Keycloak login without any email hint
   */
  onSignInWithSSO(): void {
    this._auth.login();
  }
}
